<template>
  <v-app style="background-color: #f8f9fb">
    <v-container style="background-color: #eee" fluid tag="section">
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-link-variant"
            title="Colaboradores"
            color="rgb(71 130 180)"
            style="margin-top: 60px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-row class="mt-3">
              <v-col cols="12" class="d-flex justify-end" style="gap: 10px;">
                <v-btn
                  v-if="!showFormulario"
                  small
                  outlined
                  color="teal darken-2"
                  :loading="loadingSync"
                  @click="sincronizar_solides()"
                >
                  <v-icon left>mdi-sync</v-icon>Sincronizar com Sólides
                </v-btn>
                <v-btn
                  v-if="!showFormulario"
                  small
                  color="primary"
                  :loading="loadingSolides"
                  @click="abrirDialogNovoColaborador()"
                >
                  <v-icon left>mdi-plus</v-icon>Adicionar
                </v-btn>
                <v-btn
                  v-if="showFormulario && !showEditar"
                  small
                  outlined
                  color="grey darken-1"
                  @click="cancelarFormulario()"
                >
                  <v-icon left>mdi-close</v-icon>Cancelar
                </v-btn>
              </v-col>
            </v-row>

            <v-dialog v-model="dialogSolides" max-width="980px">
              <v-card>
                <v-card-title>
                  <span>Selecionar colaborador Solides</span>
                </v-card-title>
                <v-card-text>
                  <v-row class="px-0 py-0">
                    <v-col cols="6"></v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="searchSolides"
                        append-icon="mdi-magnify"
                        label="Procurar"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-data-table
                    style="margin-top: 1rem"
                    class="elevation-0"
                    :headers="headerSolides"
                    :items="listaColaboradoresSolides"
                    :search="searchSolides"
                    :loading="loadingSolides"
                    :items-per-page="50"
                    loading-text="Carregando colaboradores..."
                    no-data-text="Nenhum colaborador disponivel"
                    items-per-page-text="Linhas por página"
                  >
                    <template v-slot:no-results>
                      <div class="pa-5 text-center">
                        <div class="mb-3">Nenhum colaborador Solides encontrado para esta busca.</div>
                        <v-btn small color="primary" @click="abrirFormularioSemSolides()">
                          <v-icon left>mdi-account-plus</v-icon>Cadastrar sem vínculo Solides
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:no-data>
                      <div class="pa-5 text-center">
                        <div class="mb-3">Nenhum colaborador Solides disponivel.</div>
                        <v-btn small color="primary" @click="abrirFormularioSemSolides()">
                          <v-icon left>mdi-account-plus</v-icon>Cadastrar sem vínculo Solides
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:item="row">
                      <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                        <td class="linha" width="300px" style="font-size: 11px;">
                          {{ row.item.nome }}
                        </td>
                        <td class="linha">
                          {{ row.item.cpf }}
                        </td>
                        <td class="linha">
                          {{ row.item.email }}
                        </td>
                        <td class="linha">
                          <v-chip color="green darken-1" text-color="white" small>
                            {{ getStatus(row.item.status) }}
                          </v-chip>
                        </td>
                        <td class="linha">
                          <v-btn
                            small
                            color="primary"
                            @click="selecionarColaboradorSolides(row.item)"
                          >
                            Selecionar
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                  <v-btn outlined small color="grey darken-1" @click="fecharDialogSolides()">
                    <v-icon left>mdi-close</v-icon>Cancelar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-form v-if="showFormulario" ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <!-- Nome Completo -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Nome Completo</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="colaborador.nome"
                    label="Nome Completo"
                    required
                    :rules="[(v) => !!v || 'Este campo é obrigatório']"
                  ></v-text-field>
                </v-col>

                <!-- cpf -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>CPF</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="colaborador.cpf"
                    label="CPF"
                    required
                    v-mask="'###.###.###-##'"
                    :rules="[(v) => !!v || 'Este campo é obrigatório']"
                  ></v-text-field>
                </v-col>

                <!-- Telefone -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Telefone</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="colaborador.telefone"
                    label="Telefone"
                    v-mask="'(##) #####-####'"
                    required
                  ></v-text-field>
                </v-col>

                <!-- E-mail -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>E-mail</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="colaborador.email"
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Cargo -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Cargo</span>
                  <v-select
                    dense
                    solo-inverted
                    v-model="colaborador.cargo"
                    :items="cargos"
                    label="Cargo"
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                  ></v-select>
                </v-col>

                <!-- Empresa -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Empresa</span>
                  <v-select
                    dense
                    solo-inverted
                    v-model="colaborador.empresa"
                    :items="empresas"
                    label="Empresa"
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                  ></v-select>
                </v-col>
                <!-- Departamento -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Departamento</span>
                  <v-select
                    dense
                    solo-inverted
                    v-model="colaborador.departamento"
                    :items="departamentos"
                    label="Departamento"
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Número de Série</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="colaborador.serie"
                    label="Número de Série"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Data de Nascimento -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Data de Nascimento</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="colaborador.dtNascimento"
                    label="Data de Nascimento"
                    type="date"
                  ></v-text-field>
                </v-col>

                <!-- Status -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Status</span>
                  <v-switch
                    color="blue"
                    v-model="colaborador.status"
                    label="Status"
                    class="mt-0"
                  ></v-switch>
                </v-col>
              </v-row>

              <v-card-actions class="d-flex justify-end">
                <v-btn
                  small
                  v-if="!showEditar"
                  :loading="loadingCreate"
                  color="primary"
                  @click="adiciona_colaborador()"
                  class="pr-4"
                >
                  <v-icon left>mdi-plus</v-icon>Adicionar Colaborador
                </v-btn>
                <v-btn
                  outlined
                  small
                  v-if="showEditar"
                  color="red"
                  @click="clear_atualizacao()"
                >
                  <v-icon left>mdi-cancel</v-icon>Cancelar Edição
                </v-btn>
                <v-btn
                  small
                  v-if="showEditar"
                  :loading="loadingUpdate"
                  color="warning"
                  @click="atualizar_colaborador(colaborador)"
                  class="mr-0"
                >
                  <v-icon left>mdi-update</v-icon>Atualizar Colaborador
                </v-btn>
              </v-card-actions>
            </v-form>
            <v-row class="px-0 py-0">
              <v-col cols="6"></v-col>
              <v-col cols="6"
                ><v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Procurar"
                  single-line
                  hide-details
                ></v-text-field
              ></v-col>
            </v-row>
            <v-data-table
              style="margin-top: 1rem"
              :headers="header"
              :items="listaColaboradores"
              :search="search"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <br />
              <br />
              <br />
              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha">
                    <v-chip
                      :color="getStatusCor(row.item.empresa)"
                      text-color="white"
                    >
                      {{ row.item.empresa }}
                    </v-chip>
                  </td>
                  <td class="linha" width="300px">
                    {{ row.item.nome }}
                  </td>
                  <td class="linha">
                    {{ row.item.cpf }}
                  </td>

                  <td class="linha">
                    {{ row.item.telefone }}
                  </td>

                  <td class="linha">
                    {{ row.item.email }}
                  </td>

                  <td class="linha">
                    {{ row.item.cargo }}
                  </td>
                  <td class="linha">
                    {{ formatarDataBR(row.item.dtNascimento) }}
                  </td>
                  <td class="linha">
                    <v-chip
                      :color="getStatusDisparoCor(row.item.status)"
                      text-color="white"
                    >
                      {{ getStatus(row.item.status) }}
                    </v-chip>
                  </td>
                  <td class="linha">
                    <v-btn
                      @click="editarColaborador(row.item)"
                      text
                      small
                      color="warning"
                    >
                      <v-icon dark> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { ContentLoader } from "vue-content-loader";
import VuetifyMoney from "./components/VuetifyMoney.vue";
import rh from "../../services/rh";

export default {
  name: "MensageriaCobranca",
  components: {
    apexcharts: ContentLoader,
    "vuetify-money": VuetifyMoney,
  },

  created() {},

  mounted() {
    this.consultar_colaboradores();
  },

  computed: {},

  data() {
    return {
      search: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingSolides: false,
      loadingSync: false,
      valid: false,
      dialog: false,
      dialogSolides: false,
      showEditar: false,
      showFormulario: false,
      listaColaboradores: [],
      listaColaboradoresSolides: [],
      searchSolides: "",
      colaborador: {
        id: 0,
        idSolides: null,
        idWk: "",
        nome: "",
        cpf: "",
        dtNascimento: "",
        telefone: "",
        email: "",
        cargo: "",
        empresa: "",
        status: true,
        serie: "",
        departamento: "",
      },
      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,
      localSelectedStartDateISO: "",
      localSelectedEndDateISO: "",
      header: [
        { text: "Empresa", value: "empresa" },
        { text: "Nome", value: "nome", width: "300px" },
        { text: "CPF", value: "cpf" },
        { text: "Telefone", value: "telefone" },
        { text: "E-mail", value: "email" },
        { text: "Cargo", value: "cargo" },
        { text: "Nascimento", value: "dtNascimento" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "acao" },
      ],
      headerSolides: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Status", value: "status" },
        { text: "Acoes", value: "acao", sortable: false },
      ],
      isLoading: false,
      departamentos: [
        "ADMINISTRAÇÃO E ATENDIMENTO",
        "ADMINISTRATIVO",
        "ADMINISTRATIVO/FINANCEIRO",
        "CALL CENTER",
        "CALL CENTER - VENDAS",
        "CALL CENTER - COBRANÇA",
        "COMERCIAL",
        "CORPORATIVO",
        "DIRETORIA",
        "FATURAMENTO",
        "FINANCEIRO",
        "FLORICULTURA",
        "LANCHONETE",
        "LOGISTICA E MANUTENCAO",
        "MANUTENÇÃO",
        "OPERAÇÕES",
        "RECURSOS HUMANO",
        "RECURSOS HUMANOS",
        "REGULACAO SEGURO",
        "RELACIONAMENTO AO CLIENTE",
        "SAC - SERVICO DE ATENDIMENTO AO CONSUMIDOR",
        "SEPULTAMENTO",
        "SERVICOS FUNERARIOS",
        "TESOURARIA",
        "VENDAS",
      ],

      empresas: [
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "PARQUE DAS FLORES",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
      ],
      cargos: [
        "AGENTE FUNERÁRIO TANATOPRAXISTA",
        "AGENTE FUNERÁRIO",
        "ANALISTA CONTÁBIL",
        "ANALISTA DE CONTROLE DA QUALIDADE",
        "ANALISTA DE FOLHA DE PAGAMENTO",
        "ANALISTA DE SUPORTE COMPUTACIONAL",
        "ANALISTA TEC. INFORMAÇÃO",
        "ASSESORA JURIDÍCA",
        "ASSISTENTE ADMINISTRATIVO - JOVEM APRENDIZ",
        "ASSISTENTE ADMINISTRATIVO FINANCEIRO",
        "ASSISTENTE ADMINISTRATIVO",
        "ASSISTENTE DE COMPRAS",
        "ASSISTENTE DE DEPARTAMENTO PESSOAL",
        "ASSISTENTE DE MANUTENÇÃO",
        "ASSISTENTE DE MARKETING",
        "ASSISTENTE DE QUALIDADE",
        "ASSISTENTE DE RECURSOS HUMANOS",
        "ASSISTENTE DE RH",
        "ASSISTENTE DE VENDAS",
        "ATENDENTE DE LANCHONETE",
        "AUX. DE MANUTENÇÃO II",
        "AUX. DE SERVIÇOS GERAIS",
        "AUXILIAR ADMINISTRATIVO - JOVEM APRENDIZ",
        "AUXILIAR ADMINISTRATIVO",
        "AUXILIAR DE ALMOXARIFADO",
        "AUXILIAR DE COMPRAS",
        "AUXILIAR DE MANUTENÇÃO I",
        "AUXILIAR DE RECURSOS HUMANOS",
        "AUXILIAR DE VENDAS",
        "CONTADOR ADJUNTO",
        "CONTROLLER",
        "COORDENADOR DE CAMPO",
        "COORDENADOR DE COMPRAS",
        "COORDENADOR DE VENDAS",
        "COORDENADOR(A) DE CONTROLADORIA",
        "COORDENADOR(A) DE SERVIÇO",
        "COORDENADORA DE RECEPÇÃO",
        "DIRETOR (A) ADMINISTRATIVO",
        "DIRETOR ADMINISTRATIVO E FINANCEIRO",
        "DIRETOR ADMINISTRATIVO",
        "EXECUTIVO DE VENDAS",
        "FAXINEIRO",
        "FLORISTA",
        "GERENTE ADJUNTA",
        "GERENTE ADJUNTO",
        "GERENTE ADM. FINANCEIRO",
        "GERENTE ADMINISTRATIVO",
        "GERENTE COMERCIAL",
        "GERENTE CONTABIL",
        "GERENTE DE CARTEIRA",
        "GERENTE DE DOCUMENTAÇÃO",
        "GERENTE DE MARKETING",
        "GERENTE DE PRODUÇÃO DE TECNOLOGIA DA INFORMAÇÃO",
        "GERENTE DE RH",
        "GERENTE DE UNIDADE (MASTER)",
        "GERENTE DE UNIDADE",
        "MOTOCICLISTA",
        "MOTORISTA",
        "OFICIAL DE OBRAS",
        "OFICIAL DE OBRAS",
        "OPERADOR DE TELEMARKETING",
        "OPERARADOR MÁQUINA DE BETONEIRA",
        "PADRE",
        "PEDREIRO",
        "PROGRAMADOR DE SISTEMAS DE INFORMAÇÃO",
        "RECEPCIONISTA",
        "SECRETÁRIA",
        "SEPULTADOR",
        "SEPULTADOR",
        "SERVENTE",
        "SUPERITENDENTE COMERCIAL",
        "SUPERVISOR (A) DE ATENDIMENTO AO CLIENTE",
        "SUPERVISOR (A) DE RECURSOS HUMANOS",
        "SUPERVISOR DE CAMPO",
        "SUPERVISOR DE COBRANCA",
        "SUPERVISOR DE SERVIÇOS",
        "SUPERVISOR DE VENDAS COMERCIAL",
        "SUPERVISOR FINANCEIRO",
        "SUPERVISOR(A) ADMINISTRATIVO",
        "SUPERVISOR(A) DE OPERAÇÕES",
        "SUPERVISORA DE ATENDIMENTO",
        "SUPERVISORA DE RH",
        "VENDEDOR DE COMÉRCIO VAREJISTA",
        "VENDEDOR",
        "VIGIA",
      ],
    };
  },

  methods: {
    getStatusCor(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "CEMITERIO PREVIDA SÃO MIGUEL":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";
        case "A FLOR DO CAFÉ":
          return "purple lighten-1";
        default:
          "success";
      }
    },
    getStatusDisparoCor(status) {
      switch (status) {
        case true:
          return "green darken-1";
        case false:
          return "red";
      }
    },
    getStatus(status) {
      switch (status) {
        case true:
          return "ATIVO";
        case false:
          return "DESATIVADO";
      }
    },
    editarColaborador(item) {
      this.colaborador = { ...item };
      this.showEditar = true;
      this.showFormulario = true;
    },
    clear_atualizacao() {
      this.showEditar = false;
      if (this.$refs.form) {
        this.$refs.form.reset();
      }

      this.$nextTick(() => {
        this.showFormulario = false;
        this.colaborador.status = true;
        this.colaborador.id = 0;
        this.colaborador.idSolides = null;
        this.colaborador.idWk = "";
        this.colaborador.cpf = "";
        this.colaborador.dtNascimento = "";
        this.colaborador.telefone = "";
        this.colaborador.email = "";
        this.colaborador.cargo = "";
        this.colaborador.empresa = "";
        this.colaborador.serie = "";
        this.colaborador.departamento = "";
        this.search = "";
      });
    },
    fecharDialogSolides() {
      this.dialogSolides = false;
      this.searchSolides = "";
    },
    cancelarFormulario() {
      this.clear_atualizacao();
    },
    abrirDialogNovoColaborador() {
      this.clear_atualizacao();
      this.dialogSolides = true;
      this.searchSolides = "";
      this.consultar_colaboradores_solides_disponiveis();
    },
    selecionarColaboradorSolides(item) {
      this.colaborador = {
        id: 0,
        idSolides: item.idSolides,
        idWk: item.idWk,
        nome: item.nome || "",
        cpf: item.cpf || "",
        dtNascimento: item.dtNascimento || "",
        telefone: item.telefone || "",
        email: item.email || "",
        cargo: item.cargo || "",
        empresa: item.empresa || "",
        status: true,
        serie: item.serie || "",
        departamento: item.departamento || "",
      };
      this.showEditar = false;
      this.showFormulario = true;
      this.dialogSolides = false;
    },
    abrirFormularioSemSolides() {
      this.colaborador = {
        id: 0,
        idSolides: null,
        idWk: "",
        nome: "",
        cpf: "",
        dtNascimento: "",
        telefone: "",
        email: "",
        cargo: "",
        empresa: "",
        status: true,
        serie: "",
        departamento: "",
      };
      this.showEditar = false;
      this.showFormulario = true;
      this.dialogSolides = false;
      this.searchSolides = "";
    },
    convertDate(dateString, format = "iso") {
      if (!dateString) return "";

      if (format === "iso") {
        // Verifica se a string está no formato ISO completo (contém 'T')
        if (dateString.includes("T")) {
          dateString = dateString.split("T")[0]; // Remove a parte do horário
        }

        // Converte de ISO (YYYY-MM-DD) para BR (DD/MM/YYYY)
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
      } else if (format === "br") {
        // Converte de BR (DD/MM/YYYY) para ISO (YYYY-MM-DD)
        const [day, month, year] = dateString.split("/");
        return `${year}-${month}-${day}`;
      }

      return dateString; // Retorna a string original se o formato não for reconhecido
    },
    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"),
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role),
        );
        return hasAnyRequiredRole;
      }
    },

    adiciona_colaborador() {
      if (this.colaborador.id === 0) {
        this.colaborador.id = null;
      }

      this.loadingCreate = true;

      if (this.$refs.form.validate()) {
        rh.salvar_colaborador(this.colaborador)
          .then((response) => {
            this.clear_atualizacao();
            this.valid = false;
          })
          .catch((e) => {
            if (e.response && e.response.status === 409) {
              window.alert("[ERRO] CPF já cadastrado!");
              return;
            }
            console.log(e);
          })
          .finally(() => {
            this.consultar_colaboradores();
            this.loadingCreate = false;
          });
      } else {
        this.loadingCreate = false;
      }
    },

    atualizar_colaborador(item) {
      this.loadingUpdate = true;

      if (this.$refs.form.validate()) {
        rh.atualizar_colaborador(item)
          .then((response) => {
            this.clear_atualizacao();
            this.valid = false;
          })
          .catch((e) => {
            if (e.response && e.response.status === 409) {
              window.alert("[ERRO] CPF já cadastrado!");
              return;
            }
            console.log(e);
          })
          .finally(() => {
            this.consultar_colaboradores();
            this.loadingUpdate = false;
          });
      } else {
        this.loadingUpdate = false;
      }
    },

    consultar_colaboradores() {
      rh.lista_colaboradores()
        .then((response) => {
          this.listaColaboradores = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    consultar_colaboradores_solides_disponiveis() {
      this.loadingSolides = true;
      rh.lista_colaboradores_solides_disponiveis()
        .then((response) => {
          this.listaColaboradoresSolides = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loadingSolides = false;
        });
    },

    formatarDataBR(dataStr) {
      if (!dataStr) return "-";
      if (dataStr.includes("-")) {
        const parts = dataStr.split("T")[0].split("-");
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return dataStr;
    },

    sincronizar_solides() {
      if (!window.confirm("Deseja sincronizar as datas de nascimento de todos os colaboradores com a base do Sólides?")) {
        return;
      }
      this.loadingSync = true;
      rh.sincronizar_nascimento_solides(true)
        .then((response) => {
          const res = response.data;
          const msg = `Sincronização concluída!\n\n` +
            `• Analisados: ${res.totalAnalisados}\n` +
            `• Atualizados com sucesso: ${res.totalAtualizados}\n` +
            `• Já atualizados: ${res.totalJaAtualizados}\n` +
            `• Sem cadastro no Sólides: ${res.totalSemSolides}\n` +
            `• Sem data no Sólides: ${res.totalSemDataSolides}`;
          window.alert(msg);
          this.consultar_colaboradores();
        })
        .catch((err) => {
          console.error("Erro ao sincronizar com Sólides:", err);
          window.alert("Erro ao sincronizar com Sólides. Tente novamente.");
        })
        .finally(() => {
          this.loadingSync = false;
        });
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}

.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: rgb(71 130 180);
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.card-container {
  display: flex;
  justify-content: space-around;
}
</style>
